import L from "leaflet";

const createIcon = (iconUrl: string) => new L.Icon({
  iconUrl,
  shadowUrl: '../../../../../assets/icons/icon-marker-shadow.png',
  iconSize: [25, 25],
  iconAnchor: [12, 25],
  popupAnchor: [1, -34],
  shadowSize: [21, 21]
});

const createColoredIcon = (color: string): L.DivIcon => {
  return L.divIcon({
    className: 'custom-icon', // Optional CSS class
    html: `
      <div style="
        position: relative;
        width: 25px;
        height: 25px;
      ">
        <svg xmlns="http://www.w3.org/2000/svg"
             version="1.0" width="100%" height="100%" viewBox="0 0 512 512"
             preserveAspectRatio="xMidYMid meet">
          <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
            <path d="M2375 5109 c-525 -55 -1004 -343 -1288 -774 -370 -562 -418 -1382
            -118 -2000 49 -100 186 -304 820 -1220 419 -605 766 -1100 771 -1100 5 0 352
            495 771 1100 821 1186 835 1209 914 1449 192 586 108 1285 -212 1771 -356 539
            -1005 843 -1658 774z m327 -1183 c254 -54 446 -278 464 -541 16 -233 -113
            -458 -323 -563 -105 -52 -171 -65 -297 -60 -157 7 -272 58 -384 169 -113 112
            -163 228 -170 390 -7 183 42 313 168 439 149 150 341 208 542 166z" fill="${color}"/>
          </g>
        </svg>
      </div>
    `,
    iconSize: [25, 25], // Match the static icon size
    iconAnchor: [12, 25],
    popupAnchor: [1, -34],
  });
};

export const defaultIcon = createIcon('../../../../../assets/icons/icon-marker.png');
export const checkedIcon = createIcon('../../../../../assets/icons/icon-marker-checked.png');
export const starterIcon = createIcon('../../../../../assets/icons/icon-marker-starter.png');
export const currentLocationIcon = createIcon('../../../../../assets/icons/icon-current-location.png');

export const dynamicIcon = createColoredIcon;
